import { createAction } from 'redux-actions';

export type CreatePollPayload = {
  question: string;
  answers: any[];
  refreshAfterSubmit?: boolean;
};
export const createPollRequest = createAction(
  'POLL.CREATE_REQUEST',
  (payload: CreatePollPayload) => payload
);
export const createPollSuccess = createAction(
  'POLL.CREATE_SUCCESS',
  payload => payload
);

export type UpdatePollPayload = CreatePollPayload & { pollId: number };
export const updatePollRequest = createAction(
  'POLL.UPDATE_REQUEST',
  (payload: UpdatePollPayload) => payload
);
export const updatePollSuccess = createAction(
  'POLL.UPDATE_SUCCESS',
  payload => payload
);

export const requestFailure = createAction('POLL.REQUEST_FAILURE', () => ({}));
